import React, { Component } from "react";
import SharedHelmet from "../Helmet";
import ramadanImg from "../../../images/ramadan.webp";
import eidAdhaImg from "../../../images/eid-adha.webp";
import eidFatrImg from "../../../images/eid-fatr.webp";
import shabanImg from "../../../images/eid-adha.webp";
import hijriImg from "../../../images/eid-adha.webp";
import motherImg from "../../../images/mother.webp";
import footballImg from "../../../images/football.webp";
import summerImg from "../../../images/summer.webp";

class Articles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "Divers",
      links: {
        technology: [],
        health: [{}],
        women: [{}],
        Divers: [
          {
            id: 1,
            title: "Jours restants jusqu'à Ramadan 2027",
            url: "/articles-fr/ramadan/",
            imageUrl: ramadanImg,
            description: "Découvrez la date du Ramadan 2027 maintenant",
          },
          {
            id: 2,
            title: "Jours restants jusqu'à l'Aïd al-Adha 2026",
            url: "/articles-fr/eid-adha/",
            imageUrl: eidAdhaImg,
            description: "Découvrez la date de l'Aïd al-Adha 2026 maintenant",
          },
          {
            id: 3,
            title: "Jours restants jusqu'à l'Aïd al-Fitr 2026",
            url: "/articles-fr/eid-fatr/",
            imageUrl: eidFatrImg,
            description: "Découvrez la date de l'Aïd al-Fitr 2026 maintenant",
          },
          {
            id: 4,
            title: "Jours restants jusqu'à la Nuit du mi-Sha'ban 2027",
            url: "/articles-fr/shaban/",
            imageUrl: shabanImg,
            description: "Découvrez la date de la Nuit du mi-Sha'ban 2027 maintenant",
          },
          {
            id: 5,
            title: "Jours restants jusqu'au Nouvel An hégirien 2026",
            url: "/articles-fr/hijri/",
            imageUrl: hijriImg,
            description: "Découvrez la date du Nouvel An hégirien 1448 maintenant",
          },
          {
            id: 6,
            title: "Jours restants jusqu'à la Fête des Mères 2026",
            url: "/articles-fr/motherday/",
            imageUrl: motherImg,
            description: "Découvrez la date de la Fête des Mères 2026 maintenant",
          },
          {
            id: 7,
            title: "Jours restants jusqu'à la Coupe du Monde 2026",
            url: "/articles-fr/worldcup/",
            imageUrl: footballImg,
            description: "Découvrez le décompte jusqu'à la Coupe du Monde FIFA 2026",
          },
          {
            id: 8,
            title: "Jours restants jusqu'aux Jeux Olympiques 2028",
            url: "/articles-fr/olympics/",
            imageUrl: footballImg,
            description: "Découvrez le décompte jusqu'aux Jeux Olympiques 2028 à Los Angeles",
          },
          {
            id: 9,
            title: "Jours restants jusqu'à la Coupe d'Asie 2027",
            url: "/articles-fr/asian-cup/",
            imageUrl: footballImg,
            description: "Découvrez le décompte jusqu'à la Coupe d'Asie AFC 2027",
          },
          {
            id: 10,
            title: "Jours restants jusqu'à l'Été 2026",
            url: "/articles-fr/summer/",
            imageUrl: summerImg,
            description: "Découvrez combien de jours restent jusqu'au début de l'été 2026",
          },
        ],
      },
    };
  }

  handleTabClick = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  render() {
    const TITLE = "Articles et ressources - Islamiques, santé et culture";
    const DESCRIPTION =
      "Explorez le monde de la technologie, de la santé, des finances, de l'autonomisation des femmes, des conseils de beauté et des perspectives islamiques. Restez informé, en bonne santé et financièrement conscient tout en améliorant votre style de vie.";
    const KEYWORDS =
      "articles islamiques, Ramadan 2027, Aïd al-Adha 2026, Aïd al-Fitr 2026, décompte islamique, fêtes islamiques";
    const OG_URL = "https://do-calculate.com/articles-fr/";
    const { activeTab, links } = this.state;
    const activeTabLinks = links[activeTab];

    const tabContainerStyle = {
      display: "flex",
      borderBottom: "1px solid #dee2e6",
    };
    const tabButtonStyle = {
      flex: 1,
      padding: "10px 15px",
      cursor: "pointer",
      border: "none",
      background: "#f8f9fa",
      color: "#495057",
      textAlign: "center",
      fontWeight: "500",
      borderRadius: "0.25rem",
      margin: "0",
      borderBottom: "2px solid transparent",
    };
    const tabButtonActiveStyle = {
      ...tabButtonStyle,
      background: "#ffffff",
      color: "#007bff",
      borderBottom: "2px solid #007bff",
    };
    const tabContentStyle = {
      padding: "15px",
      borderTop: "1px solid #dee2e6",
    };

    const availableTabs = Object.keys(links)
      .filter((tab) => links[tab] && links[tab].some((article) => article.id))
      .map((tabName) => tabName);

    return (
      <div className="ltr">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div
          className="bg-success text-white"
          role="alert"
          style={{ padding: "15px", textAlign: "center" }}
        >
          {DESCRIPTION}
        </div>
        <hr />
        <section id="tabs">
          <div style={tabContainerStyle}>
            {availableTabs.map((tabName) => (
              <button
                key={tabName}
                style={
                  activeTab === tabName ? tabButtonActiveStyle : tabButtonStyle
                }
                onClick={() => this.handleTabClick(tabName)}
              >
                {tabName.charAt(0).toUpperCase() + tabName.slice(1)}
              </button>
            ))}
          </div>
        </section>
        {activeTabLinks && activeTabLinks.length > 0 && (
          <section id="gallery" style={tabContentStyle}>
            <div className="container">
              <div className="row">
                {activeTabLinks.map(
                  (link) =>
                    link.id && (
                      <div
                        key={link.id}
                        className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                      >
                        <div className="card">
                          <img
                            src={link.imageUrl}
                            alt={link.title}
                            className="card-img-top"
                            style={{ width: "100%", height: "200px", objectFit: "cover" }}
                          />
                          <div className="card-body">
                            <h5 className="card-title">{link.title}</h5>
                            <p className="card-text">{link.description}</p>
                            <a
                              href={link.url}
                              className="btn btn-outline-success btn-sm"
                            >
                              Lire la suite
                            </a>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}

export default Articles;
